import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { User, FileText, Package, BarChart2, ClipboardCheck } from "lucide-react";

const ProcurementIntegrationDetails = () => {
  const navigate = useNavigate();

  // Tabs state
  const [activeTab, setActiveTab] = useState("supplierMaster");

  // Static data
  const suppliers = [
    {
      supplierId: "SUP001",
      supplierName: "ABC Pharma",
      contactPerson: "Rahul Jain",
      phone: "9876543210",
      email: "contact@abcpharma.com",
      address: "123 Market St, Mumbai, MH, 400001",
      gstTaxId: "27AAECS1234F1ZP",
      licenseNumber: "LIC12345",
      bankDetails: "Bank XYZ, A/C No: 123456789",
      status: "Active",
      rating: 4.5,
    },
    {
      supplierId: "SUP002",
      supplierName: "XYZ Medicos",
      contactPerson: "Anita Sharma",
      phone: "9123456780",
      email: "contact@xyzmedicos.com",
      address: "456 Pharma St, Delhi, DL, 110001",
      gstTaxId: "07AAECX9876F1ZP",
      licenseNumber: "LIC67890",
      bankDetails: "Bank ABC, A/C No: 987654321",
      status: "Active",
      rating: 4.2,
    },
  ];

  const poList = [
    {
      poNumber: "PO20250901",
      poDate: "2025-09-01",
      supplierId: "SUP001",
      orderedBy: "Admin User",
      itemsOrdered: [
        { itemName: "Paracetamol", batchNo: "B123", expiryDate: "2026-04-01", quantity: 100, unitPrice: 5 },
        { itemName: "Ibuprofen", batchNo: "B456", expiryDate: "2025-12-01", quantity: 50, unitPrice: 7 },
      ],
      expectedDeliveryDate: "2025-09-10",
      paymentTerms: "Net 30",
      approvalStatus: "Pending",
    },
  ];

  const goodsReceipts = [
    {
      grnNumber: "GRN20250911",
      linkedPONumber: "PO20250901",
      receivedDate: "2025-09-11",
      itemsReceived: [
        { itemName: "Paracetamol", quantityReceived: 100, batchNo: "B123", expiryDate: "2026-04-01", damaged: false },
        { itemName: "Ibuprofen", quantityReceived: 49, batchNo: "B456", expiryDate: "2025-12-01", damaged: true },
      ],
      receivedBy: "Store Manager",
      invoiceNumber: "INV20250911",
      paymentStatus: "Pending",
    },
  ];

  const supplierPerformance = {
    onTimeDelivery: 92,
    qualityCompliance: 4.5,
    pricingConsistency: "Good",
    totalBusinessValue: 500000,
    feedbackNotes: "Reliable supplier with occasional delays",
  };

  const formatDate = (dateString) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  return (
    <div className=" bg-gray-50 py-8 px-4">
      <div className="max-w-7xl">
        {/* Back Button */}
       
        {/* Tabs */}
        <nav className="flex space-x-4 mb-6">
          {/* <button
            onClick={() => setActiveTab("supplierMaster")}
            className={`px-4 py-2 rounded-lg font-medium ${activeTab === "supplierMaster" ? "bg-indigo-600 text-white" : "bg-gray-200 text-gray-700"}`}
          >
            Purchase
          </button> */}
           <div className="d-flex gap-2">
            <button  onClick={() => setActiveTab("supplierMaster")} className="gradient-button">Purchase</button>
             </div>
             <div className="d-flex gap-2">
            <button  onClick={() => setActiveTab("purchaseOrders")} className="gradient-button">Stock</button>
             </div>
              <div className="d-flex gap-2">
            <button   onClick={() => setActiveTab("goodsReceipt")} className="gradient-button">Sales</button>
             </div>
         
          
        </nav>

        {/* Supplier Master */}
        {activeTab === "supplierMaster" && (
          <div className="space-y-6">
            {suppliers.map((s) => (
              <div key={s.supplierId} className="bg-white rounded-xl shadow p-6 flex flex-col md:flex-row md:justify-between md:items-center">
                <div>
                  <h2 className="font-semibold text-gray-900 flex items-center mb-2">
                    <User className="w-5 h-5 mr-2 text-blue-600" /> {s.supplierName}
                  </h2>
                  <p className="text-sm text-gray-500">ID: {s.supplierId}</p>
                  <p className="text-sm text-gray-500">Contact: {s.contactPerson} | 📞 {s.phone}</p>
                  <p className="text-sm text-gray-500">Email: {s.email}</p>
                  <p className="text-sm text-gray-500">Address: {s.address}</p>
                  <p className="text-sm text-gray-500">GST: {s.gstTaxId} | License: {s.licenseNumber}</p>
                  <p className="text-sm text-gray-500">Bank: {s.bankDetails}</p>
                </div>
                <div className="mt-4 md:mt-0 text-right">
                  <span className={`px-3 py-1 rounded-full text-sm font-medium ${s.status === "Active" ? "bg-green-100 text-green-800" : "bg-red-100 text-red-800"}`}>
                    {s.status}
                  </span>
                  <p className="text-sm text-gray-700 mt-2">Rating: {s.rating} ⭐</p>
                </div>
              </div>
            ))}
          </div>
        )}

        {/* Purchase Orders */}
        {activeTab === "purchaseOrders" && (
          <div className="space-y-6">
            {poList.map((po) => (
              <div key={po.poNumber} className="bg-white rounded-xl shadow p-6 space-y-4">
                <h2 className="font-semibold text-gray-900 flex items-center">
                  <FileText className="w-5 h-5 mr-2 text-green-600" /> Purchase Order #{po.poNumber}
                </h2>
                <p><b>PO Date:</b> {formatDate(po.poDate)}</p>
                <p><b>Supplier ID:</b> {po.supplierId}</p>
                <p><b>Ordered By:</b> {po.orderedBy}</p>
                <div className="space-y-2">
                  <h4 className="font-medium text-gray-700">Items Ordered:</h4>
                  {po.itemsOrdered.map((item, i) => (
                    <div key={i} className="flex justify-between bg-gray-50 p-2 rounded-lg border border-gray-200">
                      <p>{item.itemName}</p>
                      <p>Batch: {item.batchNo}</p>
                      <p>Expiry: {formatDate(item.expiryDate)}</p>
                      <p>Qty: {item.quantity}</p>
                      <p>Unit Price: ₹{item.unitPrice}</p>
                      <p>Total: ₹{item.quantity * item.unitPrice}</p>
                    </div>
                  ))}
                </div>
                <p><b>Expected Delivery:</b> {formatDate(po.expectedDeliveryDate)}</p>
                <p><b>Payment Terms:</b> {po.paymentTerms}</p>
                <p><b>Approval Status:</b> {po.approvalStatus}</p>
              </div>
            ))}
          </div>
        )}

        {/* Goods Receipt */}
        {activeTab === "goodsReceipt" && (
          <div className="space-y-6">
            {goodsReceipts.map((grn) => (
              <div key={grn.grnNumber} className="bg-white rounded-xl shadow p-6 space-y-4">
                <h2 className="font-semibold text-gray-900 flex items-center">
                  <Package className="w-5 h-5 mr-2 text-purple-600" /> GRN #{grn.grnNumber}
                </h2>
                <p><b>Linked PO:</b> {grn.linkedPONumber}</p>
                <p><b>Received Date:</b> {formatDate(grn.receivedDate)}</p>
                <div className="space-y-2">
                  <h4 className="font-medium text-gray-700">Items Received:</h4>
                  {grn.itemsReceived.map((item, i) => (
                    <div key={i} className="flex justify-between bg-gray-50 p-2 rounded-lg border border-gray-200">
                      <p>{item.itemName}</p>
                      <p>Qty: {item.quantityReceived}</p>
                      <p>Batch: {item.batchNo}</p>
                      <p>Expiry: {formatDate(item.expiryDate)}</p>
                      <p>{item.damaged ? "Damaged" : "OK"}</p>
                    </div>
                  ))}
                </div>
                <p><b>Received By:</b> {grn.receivedBy}</p>
                <p><b>Invoice Number:</b> {grn.invoiceNumber}</p>
                <p><b>Payment Status:</b> {grn.paymentStatus}</p>
              </div>
            ))}
          </div>
        )}

        {/* Supplier Performance */}
        {activeTab === "performance" && (
          <div className="bg-white rounded-xl shadow p-6 space-y-3">
            <h2 className="font-semibold text-gray-900 flex items-center mb-2">
              <BarChart2 className="w-5 h-5 mr-2 text-indigo-600" /> Supplier Performance
            </h2>
            <p><b>On-time Delivery:</b> {supplierPerformance.onTimeDelivery}%</p>
            <p><b>Quality Compliance:</b> {supplierPerformance.qualityCompliance} / 5</p>
            <p><b>Pricing Consistency:</b> {supplierPerformance.pricingConsistency}</p>
            <p><b>Total Business Value:</b> ₹{supplierPerformance.totalBusinessValue.toLocaleString()}</p>
            <p><b>Feedback / Notes:</b> {supplierPerformance.feedbackNotes}</p>
          </div>
        )}

        {/* Reports & Analytics */}
        {/* {activeTab === "reports" && (
          <div className="bg-white rounded-xl shadow p-6">
            <h2 className="font-semibold text-gray-900 flex items-center mb-2">
              <ClipboardCheck className="w-5 h-5 mr-2 text-indigo-600" /> Reports & Analytics
            </h2>
            <p>Reports UI and export functionality to be implemented...</p>
          </div>
        )} */}

      </div>
    </div>
  );
};

export default ProcurementIntegrationDetails;
